import React from 'react';
import { Tab } from '@lux/tabs';

import { ContinueShoppingCategory } from '../types';
import * as S from './styles';
import { Chip } from './chip';

interface CategoryTabsProps {
    categories: ContinueShoppingCategory[];
    onTabChange: (params: { index: number; value: string }) => void;
}

export const CategoryTabs: React.FC<CategoryTabsProps> = ({ categories, onTabChange }) => {
    return (
        <S.TabListWrapper>
            <S.StyledTabList aria-labelledby="continue-shopping-title" onChange={onTabChange}>
                {categories.map(category => (
                    <Tab key={category.categoryId} asChild for={category.categoryId.toString()}>
                        <Chip>{category.categoryName}</Chip>
                    </Tab>
                ))}
            </S.StyledTabList>
        </S.TabListWrapper>
    );
};
